import * as iOSBridge from "iOSBridge";

/**
 * Shares a link by the system's share sheet: the iOS app's own, or the
 * browser's (Web Share API) on phones; elsewhere, copies it to share.
 */
export const shareLink = async ({
  title,
  url,
}: {
  title: string;
  url: string;
}) => {
  const app = iOSBridge.get();
  if (app) {
    app.share({ title, url });
  } else if (navigator.share) {
    await navigator.share({ title, url }).catch(() => {
      // Cancelled
    });
  } else {
    await navigator.clipboard.writeText(url);
    alert("Link copied to clipboard, now go and share it!");
  }
};

/** Whether `shareLink` opens a share sheet, rather than copying the link */
export const sharesBySheet = () => Boolean(iOSBridge.get() || navigator.share);
